export default __webpack_public_path__ + "static/media/speed.ce1cc2ed.svg";